import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root'
})
export class ToggleGuard implements CanActivate {
  enableStatus: any;
  constructor(private router: Router, private featureFlagService: TranslationService){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.enableStatus = this.featureFlagService.featureFlags;
      let page = route.data['page']
      if(this.enableStatus.general[page]){
        return true;
      } else {
        this.router.navigateByUrl('coming-soon');
        return false;
      }
  }
  
}